import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex justify-between items-center h-20 md:h-28">
          <Link to="/" className="flex items-center" data-testid="nav-logo-link">
            <img 
              src="/logo.png"
              alt="Family Shoe Store" 
              className="h-16 md:h-24 w-auto hover:opacity-90 transition-opacity"
              data-testid="nav-logo-image"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-base font-medium text-gray-700 hover:text-[#14B8A6] transition-colors"
              data-testid="nav-home-link"
            >
              Home
            </Link>
            <Link
              to="/shop"
              className="text-base font-medium text-gray-700 hover:text-[#14B8A6] transition-colors"
              data-testid="nav-shop-link"
            >
              Shop
            </Link>
            <Link
              to="/team"
              className="text-base font-medium text-gray-700 hover:text-[#14B8A6] transition-colors"
              data-testid="nav-team-link"
            >
              Our Team
            </Link>
            <Link
              to="/contact"
              className="text-base font-medium text-gray-700 hover:text-[#14B8A6] transition-colors"
              data-testid="nav-contact-link"
            >
              Contact
            </Link>
          </div>

          <button
            className="md:hidden text-[#14B8A6]"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden py-4 space-y-4" data-testid="mobile-menu">
            <Link
              to="/"
              className="block text-base font-medium text-gray-700 hover:text-[#14B8A6]"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-nav-home"
            >
              Home
            </Link>
            <Link
              to="/shop"
              className="block text-base font-medium text-gray-700 hover:text-[#14B8A6]"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-nav-shop"
            >
              Shop
            </Link>
            <Link
              to="/team"
              className="block text-base font-medium text-gray-700 hover:text-[#14B8A6]"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-nav-team"
            >
              Our Team
            </Link>
            <Link
              to="/contact"
              className="block text-base font-medium text-gray-700 hover:text-[#14B8A6]"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-nav-contact"
            >
              Contact
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;